// @flow

import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../../../../assets/styles/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import type {Theme} from '@material-ui/core';
type Props = {
  options: string[],
};

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    border: `1px solid ${colors.grey300}`,
    padding: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  chip: {
    background: colors.grey200,
    padding: theme.spacing(1),
    fontSize: 14,
    color: '#3A3A49',
  },
  optList: {
    grow: 1,
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
}));
export default function MultiOptionPreview({options}: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <div className={classes.header} onClick={() => setIsOpen(ps => !ps)}>
        <div className={classes.optList}>
          {options.map(opt => (
            <div className={classes.chip}>{opt}</div>
          ))}
        </div>
        <div>{!isOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}</div>
      </div>
    </div>
  );
}
